import React from 'react';
import { Analytics } from "@vercel/analytics/react"
import {BrowserRouter, Route, Routes} from "react-router-dom";
import App from "../App";
import About from "../modules/about/About";
import Portfolio from "../modules/portfolio/Portfolio";
import Contact from "../modules/contact/Contact";
import HomePage from "../modules/home/Home";

const AppRoute = () => {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<App/>}>
                        <Route path="/" element={<HomePage/>}/>
                        <Route path="about" element={<About/>}/>
                        <Route path="portfolio" element={<Portfolio/>}/>
                        <Route path="contact" element={<Contact/>}/>
                        <Route element={<Analytics />}></Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    );
};

export default AppRoute;